import {OnInit} from '@angular/core';
import {Component, ChangeDetectionStrategy, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {FullCalendarModule, CalendarOptions} from '@fullcalendar/angular';
import {FullCalendarComponent} from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'; // for dateClick
import {document} from 'ngx-bootstrap/utils';
import {Router} from '@angular/router';
import {CalendarService} from '@components/calendar/calendar.service';
import {BackendResponse} from "@app/interfaces/backendResponse";


FullCalendarModule.registerPlugins([
    interactionPlugin,
    dayGridPlugin,
    timeGrigPlugin
]);

@Component({
    selector: 'app-calendar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css']
})


export class CalendarComponent implements OnInit {

    constructor(private taskService: TaskService,
                private dialogData: MatDialog,
                private router: Router,
                private calendarService: CalendarService) {
    }


    events = [];
    loader: boolean;
    eventSources: any[] = [];
    count = 0;

    calendarOptions: CalendarOptions = {
        headerToolbar: {left: 'dayGridMonth,timeGridWeek', center: 'title', right: 'prev next'},
        initialView: 'dayGridMonth',
        buttonText: {
            today: 'Danas',
            month: 'Mjesec',
            week: 'Nedelja',
            day: 'Dan',
            list: 'Lista'
        },
        locale: 'sr-ME',
        selectable: true,
        height: '88%',
        select: this.onSelectDates.bind(this),   // bind is important!
        eventColor: '#153de7',
        dayMaxEventRows: true,
        eventClick: this.navigatetToRoute.bind(this)
    };

    @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;

    ngOnInit() {
        const x = document.getElementById('getEvents');
        x.click();
        this.count = 1;
    }

    getEvents() {

        if (this.count === 0) {
            this.events = [];
            this.calendarService.getEvents().subscribe((result: BackendResponse) => {
                if (result.type === 'success') {
                    for (const item of Object.values(result.data)) {
                        const x = [];
                        x['title'] = item['title'];
                        if (item['type'] === 'meeting') {
                            x['start'] = item['meeting_time']['start'];
                            x['end'] = item['meeting_time']['end'];
                        } else if (item['type'] === 'task') {
                            x['start'] = item['execution'] !== null ? item['execution'] : item['deadline'];
                            x['end'] = item['end_time'] === null ? item['deadline'] : item['end_time'];
                            // x['backgroundColor']='#9583d0';
                        }
                        x['id'] = item['_id'];
                        x['sort'] = item['sort'];
                        this.events.push(x);
                    }
                    this.calendarOptions.events = this.events;
                    const click = document.getElementById('getEvents');
                    click.click();
                    this.count = 1;
                }

            });

        }
    }


    handleDateClick(arg) {
        alert('date click! ' + arg.dateStr);
    }


    clickOnDate(data) {
        this.dialogData.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'calendarDateClick',
                data: data,
                sort: 'task'
            }
        });
    }

    navigatetToRoute(event) {
        this.router.navigateByUrl('/view-task/' + event.event.id);
    }

    updateHeader() {
        this.calendarOptions.headerToolbar = {
            left: 'prev,next myCustomButton',
            center: 'title',
            right: ''
        };
    }

    onSelectDates(data) {

        const MyDate = new Date();
        MyDate.setDate(MyDate.getDate() + 20);

        data.allDay = false;
        data.end.setMinutes(data.end.getMinutes() - 1);
        const month = ('0' + (data.end.getMonth() + 1)).slice(-2);
        data.endStr = data.end.getFullYear() + '-' + month + '-' + ('0' + (data.end.getDate())).slice(-2);

        if (data.end.getMinutes() === 59) {
            data.end.setMinutes(0);
            data.end.setHours(data.end.getHours() + 1);
        } else if (data.end.getMinutes() === 29) {
            data.end.setMinutes(30);
        }

        this.dialogData.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'calendarDatesSelected',
                data: data,
                sort: 'task'
            }
        }).afterClosed().subscribe(response => {
            if (response === true) {
                this.count = 0;
                this.getEvents();
            }
        });
    }

}

